<template lang="html">
 <div class="locale-changer">
   <b-select v-model="$i18n.locale" @input="changeLocale" rounded>
     <option v-for="(lang, i) in $i18n.availableLocales" :key="`Lang${i}`" :value="lang">{{ localeNames[lang] }}</option>
   </b-select>
 </div>
</template>

<script>
export default {
  data () {
    return {
      localeNames: {
        'en': 'English',
        'fr': 'Français',
        'ja': '日本語'
      }
    }
  },
  methods: {
    changeLocale (locale) {
      localStorage.setItem('locale', locale)
    }
  }
}
</script>
